module.exports = __webpack_public_path__ + "static/media/6.9fdbf619.jpeg";